var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgD = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 29,
    rx: 3.5,
    stroke: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.521,
    y: 2.559,
    width: 22.959,
    height: 23.346,
    rx: 1.75,
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.955 9.624c.88 0 1.652.172 2.316.516a3.63 3.63 0 0 1 1.548 1.476c.368.632.552 1.368.552 2.208 0 .84-.184 1.576-.552 2.208a3.673 3.673 0 0 1-1.548 1.452c-.664.344-1.436.516-2.316.516h-2.928V9.624h2.928Zm-.06 6.948c.88 0 1.56-.24 2.04-.72s.72-1.156.72-2.028c0-.872-.24-1.552-.72-2.04-.48-.496-1.16-.744-2.04-.744h-1.188v5.532h1.188Z",
    fill: "#fff"
  })));
};
export { SvgD as ReactComponent };